import { useEffect, useRef } from "react";

const BackgroundVideo = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches && ref.current) {
      ref.current.pause();
    }
  }, []);

  return (
    <>
      <video
        ref={ref}
        data-testid="serum-video"
        className="fixed inset-0 w-full h-full object-cover z-0 pointer-events-none"
        autoPlay
        muted
        loop
        playsInline
        poster="/assets/serum-poster.jpg"
      >
        <source src="/assets/serum-loop.mp4" type="video/mp4" />
      </video>
      <div className="fixed inset-0 z-[1] bg-[#F5EFE6]/50 pointer-events-none" />
    </>
  );
};

export default BackgroundVideo;
